export default __webpack_public_path__ + "icon_car.svg";